/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersedittitle2Inputs */

const en_partnersedittitle2 = /** @type {(inputs: Partnersedittitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit partner`)
};

const de_partnersedittitle2 = /** @type {(inputs: Partnersedittitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit partner" |
*
* @param {Partnersedittitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersedittitle2 = /** @type {((inputs?: Partnersedittitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersedittitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersedittitle2(inputs)
	return de_partnersedittitle2(inputs)
});
export { partnersedittitle2 as "partnersEditTitle" }